/** @format */
import { Injectable } from '@angular/core';
import { Plan } from 'common-typescript/types';
import { BehaviorSubject, Observable, shareReplay, ShareReplayConfig, switchMap } from 'rxjs';
import { PlanEntityService } from 'sis-components/service/plan-entity.service';

@Injectable({ providedIn: 'root' })
export class MyPlanService {
    /**
     * Emits plans of the authenticated user,
     * including up-to-date data after updates.
     */
    readonly myPlans$: Observable<readonly Plan[]>;

    constructor(planEntityService: PlanEntityService) {
        // The subject is just a trick to prevent the result from being cached forever,
        // in case of a completing getMyPlans stream.
        this.myPlans$ = new BehaviorSubject(undefined).pipe(
            switchMap(() => planEntityService.getMyPlans()),
            shareReplay(<ShareReplayConfig>{ bufferSize: 1, refCount: true }), //
        );
    }
}
